module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/book-f8c1af217c0d187cf093da276233dfa1.svg";